/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Alert from 'react-s-alert';

import { Accordion } from '../../components/Accordion';
import { Button } from '../../components/Button';
import { CheckboxGroup } from '../../components/CheckboxGroup';
import { ModalComponent } from '../../components/Modal';
import { MeasurementEdit } from '../../components/MeasurementEdit';
import { AWSUpload } from '../../components/AWSUpload';

import { measurementKeys } from '../../constants/elementProps';
import { toggleDisplayMeasurement, handledMeasurementAdd } from '../../actions/elements';
import { createMesurementsImage } from '../../actions/images';
import { GREY } from '../../constants/colors';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
  padding-bottom: 120px;
  overflow: auto;
`;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  & td {
    padding: 5px;
    border-bottom: 1px solid ${GREY};
  }
`;

class ElementNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreate: false,
      showUplaod: false,
      disable: false,
    };
    this.onShowCreate = this.onShowCreate.bind(this);
    this.onHideCreate = this.onHideCreate.bind(this);
    this.onShowUpload = this.onShowUpload.bind(this);
    this.onHideUpload = this.onHideUpload.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmitUpload = this.handleSubmitUpload.bind(this);
  }

  onShowCreate() {
    this.setState({showCreate: true});
  }

  onHideCreate() {
    this.setState({showCreate: false});
  }

  onShowUpload() {
    this.setState({showUplaod: true});
  }

  onHideUpload() {
    this.setState({showUplaod: false});
  }

  handleSave(measurements) {
    this.props.handledMeasurementAdd(measurements, this.props.selectedElement.id);
    this.onHideCreate();
  }

  handleSubmitUpload(id, images) {
    if (!this.state.disable) {
      this.setState({disable: true, showUplaod: false});
      this.props.createMesurementsImage(id, images);
      Alert.info('Uploading in progress...');

      setTimeout(() => {
        this.setState({disable: false});
      }, 20);
    }

  }

  render() {
    const {
      displayedMeasurementProps, toggleDisplayMeasurement, selectedElement, user,
    } = this.props;
    const { showCreate, showUplaod } = this.state;

    return (
      <Wrapper>
        <Table>
          <tbody>
            <tr>
              <td colSpan="3">
                Number of measurements:&nbsp;
                {selectedElement && selectedElement.statistics ? selectedElement.statistics.num_of_measurements : ''}
              </td>
            </tr>
            <tr>
              <td>Qd</td>
              <td>min: {selectedElement && selectedElement.statistics ? `${selectedElement.statistics.qd_min}` : ''}</td>
              <td>max: {selectedElement && selectedElement.statistics ? `${selectedElement.statistics.qd_max}` : ''}</td>
            </tr>
            <tr>
              <td>R<sub>L</sub></td>
              <td>min: {selectedElement && selectedElement.statistics ? `${selectedElement.statistics.rl_min}` : ''}</td>
              <td>max: {selectedElement && selectedElement.statistics ? `${selectedElement.statistics.rl_max}` : ''}</td>
            </tr>
            <tr>
              <td>AVG</td>
              <td>Qd: {selectedElement && selectedElement.statistics ? `${selectedElement.statistics.avg_qd}` : ''}</td>
              <td>R<sub>L</sub>: {selectedElement && selectedElement.statistics ? `${selectedElement.statistics.avg_rl}` : ''}</td>
            </tr>
          </tbody>
        </Table>
        <br />
        <ModalComponent
          big
          handleHide={this.onHideCreate}
          open={showCreate}
          title={`${showCreate ? 'CREATE NEW' : 'EDIT'} MEASUREMENT`}
        >
          <MeasurementEdit
            onSave={this.handleSave}
          />
        </ModalComponent>
        <ModalComponent
          handleHide={this.onHideUpload}
          open={showUplaod}
          title='UPLOAD NEW IMAGE'
        >
          <AWSUpload
            handleClose={this.onHideUpload}
            handleUpload={this.handleSubmitUpload}
            measurement={selectedElement ? selectedElement.measurements : []}
          />
        </ModalComponent>
        {user.admin &&
          <div>
            <hr />
            <Button
              block
              onClick={this.onShowCreate}
            >
              CREATE MEASUREMENT
            </Button>
            <Button
              block
              onClick={this.onShowUpload}
            >
              UPLOAD IMAGE
            </Button>
          </div>
        }
        <br />
        <Accordion
          data={[
            {
              title: 'Element Props',
              content: (
                <CheckboxGroup
                  data={measurementKeys}
                  handleToggle={toggleDisplayMeasurement}
                  selected={displayedMeasurementProps}
                />
              ),
            },
          ]}
        />

      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    displayedMeasurementProps: state.elements.displayedMeasurementProps,
    selectedElement: state.elements.selectedElement,
    user: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleDisplayMeasurement,
    handledMeasurementAdd,
    createMesurementsImage,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ElementNavigation);



// WEBPACK FOOTER //
// ./src/containers/Element/navigation.js